export function useSoftwareOsLabel(os: string) {
  const softwareOsLabelPrefix = 'downloadCenterSoftware.os.';
  const { $textDictionary } = useNuxtApp();

  return $textDictionary.value[softwareOsLabelPrefix + os] || os;
}
